import type { ReactNode } from 'react';

/**
 * 表单字段容器：标签 + 控件 + 错误/提示。
 *
 * 错误用 `aria-describedby` 关联到控件，并且错误文本带 `role="alert"`，
 * 这样屏幕阅读器能立刻播报，键盘用户也能靠 `aria-invalid` 定位问题字段。
 */
export function Field({
  id,
  label,
  error,
  hint,
  children,
}: {
  id: string;
  label: string;
  error?: string | undefined;
  hint?: string | undefined;
  children: ReactNode;
}) {
  return (
    <div className="space-y-1.5">
      <label htmlFor={id} className="block text-sm font-medium">
        {label}
      </label>
      {children}
      {error ? (
        <p id={`${id}-error`} role="alert" className="text-xs text-destructive">
          {error}
        </p>
      ) : hint ? (
        <p id={`${id}-hint`} className="text-xs text-muted-foreground">
          {hint}
        </p>
      ) : null}
    </div>
  );
}
